import { render } from "./matching-start.view.vue?vue&type=template&id=bbbc0274&scoped=true&ts=true"
import script from "./matching-start.view.vue?vue&type=script&lang=ts"
export * from "./matching-start.view.vue?vue&type=script&lang=ts"

import "./matching-start.view.vue?vue&type=style&index=0&id=bbbc0274&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbbc0274"]])

export default __exports__